export const CMS_IFRAME_READY = 'CMS_IFRAME_READY';
export const CMS_HOST_AUTH = 'CMS_HOST_AUTH';
const readWalletAccessToken = (msg) => {
    const walletToken = typeof msg.walletAccessToken === 'string' ? msg.walletAccessToken.trim() : '';
    if (walletToken) {
        return walletToken;
    }
    return typeof msg.accessToken === 'string' ? msg.accessToken.trim() : '';
};
export function isCmsHostAuthMessage(data) {
    if (data == null || typeof data !== 'object') {
        return false;
    }
    const msg = data;
    return msg.type === CMS_HOST_AUTH && readWalletAccessToken(msg).length > 0;
}
export function parseCmsHostAuthMessage(data) {
    const walletAccessToken = readWalletAccessToken(data);
    const walletApiBase = typeof data.walletApiBase === 'string' && data.walletApiBase.trim()
        ? data.walletApiBase.trim()
        : undefined;
    return { walletAccessToken, walletApiBase };
}
